import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { USER_PROGRESS_ENTITY, USER_PROGRESS_EVENT } from '~/const';
import useEventListener from '~/hooks/useEventListener';
import useSendUserProgress from '~/hooks/useSendUserProgress';

const CHAPTER_VIEWED_COMPLETE = 'Chapter Viewed Complete';
const ANSWER_VIEWED_COMPLETE = 'Answer Viewed Complete';

const useTrackUserProgress = (videoId) => {
  const { sendUserProgress } = useSendUserProgress();
  const location = useLocation();
  const pathname = location?.pathname;

  //used to send OCC progress on tab close
  useEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      sendUserProgress(USER_PROGRESS_EVENT.VideoWatched, USER_PROGRESS_ENTITY.Video, videoId);
    }
  });

  useEffect(() => {
    return () => {
      if (videoId) {
        sendUserProgress(USER_PROGRESS_EVENT.VideoWatched, USER_PROGRESS_ENTITY.Video, videoId);
      }
    };
  }, [pathname, sendUserProgress, videoId]);

  useEffect(() => {
    const listener = (message) => {
      const event = message?.data?.event;

      if (videoId && (event === CHAPTER_VIEWED_COMPLETE || event === ANSWER_VIEWED_COMPLETE)) {
        sendUserProgress(USER_PROGRESS_EVENT.VideoWatched, USER_PROGRESS_ENTITY.Video, videoId);
      }
    };

    window.addEventListener('message', listener);

    return () => {
      window.removeEventListener('message', listener);
    };
  }, [sendUserProgress, videoId]);
};

export default useTrackUserProgress;
